type ButtonVariant = 'primary' | 'secondary' | 'inverse' | 'inverse-outline';

const base =
  'inline-flex min-h-[48px] items-center justify-center gap-2 whitespace-nowrap rounded-[3px] px-7 text-[15px] font-medium transition-colors duration-150 ease-out disabled:cursor-not-allowed disabled:opacity-60';

const variants: Record<ButtonVariant, string> = {
  primary: 'bg-ink text-canvas hover:bg-bronze-deep',
  secondary: 'border border-ink text-ink hover:bg-ink hover:text-canvas',
  inverse: 'bg-champagne text-ink hover:bg-canvas',
  'inverse-outline': 'border border-champagne/70 text-canvas hover:bg-canvas hover:text-ink',
};

export function buttonClasses(variant: ButtonVariant = 'primary', fullWidth = false): string {
  return `${base} ${variants[variant]} ${fullWidth ? 'w-full' : ''}`;
}
